// extracted by mini-css-extract-plugin
export default {"fade-in":"GfC5CbHXX0wGT2Tbc51A"};